import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { styles } from './template.scss';
import { FontSizes } from "../../../types/common/types";

const integrationsGridTemplate = document.createElement('template');

integrationsGridTemplate.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class="wrapper">
    <div class="content">
      <div class="grid hidden">
        <gz-grid-view class="grid-view">
            <div class="header__actions" slot="grid-header-actions-slot">
                <gz-button id="addNewButton" class="primary"></gz-button>
            </div>
        </gz-grid-view>
      </div>

      <div id="no-results" class="hidden">
        <gz-image-repo class="mt-10" state="start">
          <gz-title fontSize='${FontSizes.HEADING_4}' id="no-results-message"></gz-title>
          <gz-text id="no-results-additional-text" fontSize="14" lineHeight="2"></gz-text>

          <gz-tooltip id="no-results-add-new-tooltip">
            <gz-button id="no-results-add-new-button" class="mt-2"></gz-button>
          </gz-tooltip>
        </gz-image-repo>
      </div>
    </div>
    <gz-integrations-create-panel class="hidden"></gz-integrations-create-panel>
  </div>
`;

export default integrationsGridTemplate;
